import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import MenuIcon from "@material-ui/icons/Menu";
import KeyboardVoiceIcon from "@material-ui/icons/KeyboardVoice";
import FileUploadIcon from "@material-ui/icons/FileUpload";
import FileDownloadIcon from "@material-ui/icons/FileDownload";
import CancelIcon from "@material-ui/icons/Cancel";
import StopIcon from "@material-ui/icons/Stop";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from "@material-ui/icons/Delete";
import { CheckCircle } from "@material-ui/icons";
import HelenAPI from "@helen/sdk";
import ReactMediaRecorder from "react-media-recorder";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Redirect } from "react-router-dom";
import SkipDialog from "./SkipDialog";
import AppDialog from "./AppDialog";
import ConfirmDialog from "./ConfirmDialog";

const drawerWidth = 370;
const styles = theme => ({
  toolbar: theme.mixins.toolbar,
  button: {
    // margin: theme.spacing.unit,
    color: "#009688"
  },
  barColor: {
    backgroundColor: "#26A69A"
  },
  barBackgroundColor:{
    backgroundColor: "#B2DFDB"
  },
  raisedButton: {
    marginLeft: 30,
    backgroundColor: "#009688",
    float: "right",
    "&:hover": {
      backgroundColor: "#00695C"
    }
  },
  drawerPaper: {
    position: "realtive",
    width: drawerWidth,
    marginLeft: 10,
    marginBottom: 10
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    backgroundColor: "#F5F5F5",
    ...theme.mixins.toolbar
  },
  leftButton: {
    marginLeft: 382,
    float: "left"
  },
  menuButton: {
    marginLeft: 10,
    float: "left"
  },
  hide: {
    display: "none"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  contentShiftLeft: {
    marginLeft: drawerWidth
  },
  contentStyling: {
    width: "80%",
    margin: "auto",
    marginTop: 40,
    boxShadow: "1px 2px 4px 1px rgba(158,158,158,1)",
    padding: 30
  },
  hideInput: {
    display: "none"
  },
  mainText: {
    ...theme.typography.subheading,
    fontSize: 24
  },
  secondaryText: {
    ...theme.typography.subheading,
    fontSize: 20
  },
  progressStyle: {
    paddingTop: 20,
    fontSize: 15
  },
  actionStyles: {
    margin: "auto",
    marginTop: 20,
    textAlign: "center"
  },
  openButton: {
    color: "#009688",
    marginLeft: "75%"
  },
  nextButton: {
    float: "right"
  },
  previousButton: {
    float: "left"
  },
  pagingWrapper: {
    display: "flex",
    paddingTop: 20,
    paddingBottom: 20,
    justifyContent: "space-between"
  },
  currentPage: {
    width: 50,
    height: 20,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    textAlign: "center"
  }

});

class Recorder extends React.Component {
  state = {
    open: true,
    recordView: "1",
    targetPhrases: [],
    counterSecond: null,
    errorText: "",
    loading: true,
    selectedPhraseId: "",
    showSkipDialog: false,
    showNotifyDialog: false,
    showConfirmDialog: false,
    notifyStatus: "",
    notifyTitle: "",
    notifyText: "",
    isAttachmentSaved: false,
    hasUnsavedChanges: false,
    recordedCount: 0,
    contentloading: false,
    signOut: false,
    inValidOperation: false,
    phrasesWithoutAttachment: null,
    currentPhrasesWithoutAttachment: null,
    targetPhrasesView: [],
    currentPage: 0,
    pageCount: 0,
    currentPointer: 0,
    pageLimit: 20,
    pageNumber:0,
    pageLimits:null,
    allPhraseLoaded:false,
    phraseLimit:300,
    tempPhrasesWithoutAttach:[],
    tempLoading:false,
    isFromOpenPhrase: false,
    audioStatus: {
      playing: false,
      duration: "0",
      playBackTime: "0",
      progress: 0
    },
    datapackage: {},
    chunkNumber: 0,
    chunkSize: 100,
    allPhrases: [],
    phraseCount: 0
  };

  phraseHasAttachment(main, { attachments, translations }) {
    const attach = attachments || [];
    const translate = translations || [];
    return (
      translate.filter(({ language }) => language === main).length >
      0 &&
      (attach.length === 0 ||
        !attach.find(
          ({ language, type }) => language === main && type === "audio"
        ))
    );
  }

  chunkPhrasesFromDatapackage(dp) {
    const { chunkNumber, chunkSize } = this.state;
    const start = chunkNumber * chunkSize;
    if (start > dp.length) {
      return [];
    }
    this.setState({chunkNumber: chunkNumber + 1});
    var unrecorded = [];
    for (var i = start; i < dp.length; i++) {
      if (unrecorded.length === chunkSize) break;
      unrecorded.push(dp[i]);
    }
    return unrecorded;
  }

  initPhrases = async () => {
    const datapackage = await HelenAPI.getDatapackage(this.props.version.data.version);
    const allP = await this.phrasesFromDialogTree(datapackage);
    return allP;
  }

  getPhrasesWithoutAttachment = async (allPhrases = []) => {
    var allP = allPhrases;
    if (allP.length === 0) {
      allP = this.state.allPhrases;
    }
    this.tempPhrasesWithoutAttach = [];
    var unrecorded = this.chunkPhrasesFromDatapackage(allP);
    if (unrecorded.length < this.state.chunkSize) {
      this.allPhraseLoaded = true;
    }
    this.tempPhrasesWithoutAttach = this.tempPhrasesWithoutAttach.concat(unrecorded);
  }

  phrasesFromDialogTree = async (dp) => {
    var dialogsMap = {};
    var stack = [];
    var phraseIDS = [];
    if (!dp) {
      this.setState({
        contentloading: false,
        showNotifyDialog: true,
        notifyStatus: "",
        notifyTitle: "No datapackage",
        notifyText: `There was an error loading the datapackage.`
      });
      return;
    }
    dp.dialogs.forEach(dg => {
      dialogsMap[dg.id] = dg;
      if (dg.tags && dg.tags.indexOf("start") >= 0) {
        stack.push(dg.id);
      }
    });
    while(stack.length > 0) {
      var cur = stack.pop();
      var curD = dialogsMap[cur];
      if (!curD) continue;
      if (curD.phrase && !phraseIDS.includes(curD.phrase)) {
        phraseIDS.push(curD.phrase);
      }
      if (curD.tags && curD.tags.includes("paragraph")) {
        var para = "true";
        for (var i=0; para; i++) {
          para = curD.tags.find(t => { return t.endsWith("index_"+i) });
          if (para) {
            var paraID = para.substring(7,43);
            if (!phraseIDS.includes(paraID)) { 
              phraseIDS.push(paraID); 
            }
          }
        }
      }
      if (curD.order) stack.push(...(curD.order.reverse()));
    }
    var p = [];
    while(phraseIDS.length != 0){
      var chunk = phraseIDS.splice(0, 200);
      if(chunk.length == 1) chunk.push(chunk[0]);
      p.push(HelenAPI.getPhrasesChunk(chunk));
    }
    var pResolved = await Promise.all(p);
    let pFlat = pResolved.flat();
    const { main } = this.props.languages;
    let pWithoutAttach = pFlat.filter(e => this.phraseHasAttachment(main,e));
    return pWithoutAttach;
  }

  // Fetching the target phrases and setting the first phrase
  componentDidMount = async () => {
    this.props.setAppBar(false);
    const { main } = this.props.languages;
    try {
      //await HelenAPI.deletePhrase();
      const allP = await this.initPhrases();
      let pc = Math.floor(allP.length/this.state.chunkSize) + 1;
      this.setState({ allPhrases: allP, phraseCount: allP.length, pageCount: pc });
      await this.getPhrasesWithoutAttachment(allP);
      if (allP) {
       const phrasesWithoutAttachment = this.tempPhrasesWithoutAttach;

       const [defaultPhrase] = phrasesWithoutAttachment;
       if (!defaultPhrase) {
        this.setState({ contentloading: false });
        this.setState({
          contentloading: false,
          showNotifyDialog: true,
          notifyStatus: "",
          notifyTitle: "No phrase",
          notifyText: `There are no unrecorded phrases in this language on this instance.`
        });
        return;
      }
        const phrasesObject = phrasesWithoutAttachment.reduce(
          (acl, curr) =>
            Object.assign({}, acl, {
              [curr.id]: curr
            }),
          {}
        );
        this.phrasesWithoutAttachment = phrasesWithoutAttachment;
        this.currentPointer = phrasesWithoutAttachment.length - 1;
        const page = {
          "start":0,
          "end": phrasesWithoutAttachment.length - 1,
          "recordedCount":0
        };
        var p = 0;
        this.pageLimits = {};
        this.pageLimits[p] = page;
        this.pageNumber = p;
        const phrasesObjectView = phrasesWithoutAttachment.reduce(
            (acl, curr) =>
                Object.assign({}, acl, {
                    [curr.id]: curr
                }),
            {}
        );
        if (!main) {
          this.setState({ inValidOperation: true, loading: false });
          return;
        }
        this.userSelected = "";

        this.currentAudio = new Audio("");
        this.currentAudio.addEventListener("ended", () => {
          const audioStatus = { ...this.state.audioStatus };
          audioStatus.playing = false;
          this.setState({ audioStatus });
          setTimeout(() => {
            this.currentAudio.currentTime = 0;
          }, 500);
        });
        this.currentAudio.addEventListener("loadedmetadata", () => {
          if (this.currentAudio.duration === Infinity) {
            this.currentAudio.currentTime = 10000;
            this.setDuration = true;
          } else {
            const audioStatus = { ...this.state.audioStatus };
            audioStatus.duration = this.currentAudio.duration;
            this.setState({ audioStatus });
          }
        });
        this.currentAudio.addEventListener("timeupdate", () => this.onAudioTimeUpdate());
        this.setState({
          currentPhrasesWithoutAttachment: phrasesWithoutAttachment,
          targetPhrases: phrasesObject,
          targetPhrasesView: phrasesObjectView,
          selectedPhraseId: defaultPhrase.id,
          loading: false
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Show appbar on recorder unmount
  componentWillUnmount = () => this.props.setAppBar(true);

  onAudioTimeUpdate=()=>{
    const duration = Math.floor(this.currentAudio.duration);
    const durationStr = `${Math.floor(duration / 60)}:${`0${Math.floor(duration % 60)}`.substr(-2)}`;
    const currentTime = Math.floor(this.currentAudio.currentTime);
    const currentTimeStr = `${Math.floor(currentTime / 60)}:${`0${Math.floor(currentTime % 60)}`.substr(-2)}`;
    if (this.setDuration) {
      const audioStatus = { ...this.state.audioStatus };
      audioStatus.duration = durationStr;
      this.setState({ audioStatus });
      this.setDuration = false;
      this.currentAudio.currentTime = 0;
      return;
    }
    let progress = 0;
    if (duration > 0) {
      progress = Math.floor(
        this.currentAudio.currentTime / this.currentAudio.duration * 100
      );
    }
    const audioStatus = { ...this.state.audioStatus };
    audioStatus.playBackTime = currentTimeStr;
    audioStatus.progress = progress;
    this.setState({ audioStatus });
  }

  // Counter function for recording
  tick = startRecording => {
    this.setState(prevState => ({
      counterSecond: prevState.counterSecond - 1
    }));
    if (this.state.counterSecond === 0) {
      startRecording();
      clearInterval(this.interval);
    }
  };

  // Handle saving a Record
  saveRecording = async (currentPhrase, main) => {
    console.log("saving currentphrase:",currentPhrase);
    this.setState({ contentloading: true });
    try {
      const attachemntList = await currentPhrase.getAttachments();
      const targetAttachment = attachemntList.find(
        x => x.language === main && x.type === "audio"
      );
      let hasDelete = false;
      if (targetAttachment) {
        await currentPhrase.deleteAttachment(targetAttachment.id);
        hasDelete = true;
      }
      let blob = null;
      const xhr = new XMLHttpRequest();
      xhr.open("GET", currentPhrase.getRecordedTranslation({ language: main }));
      xhr.responseType = "blob";
      xhr.onload = async function() {
        blob = xhr.response;
        const audioFile = new File([blob], "AudioAttachment.wav", {
          type: "audio/wav",
          lastModified: Date.now()
        });
        const data = {
          type: "audio",
          language: main,
          file: audioFile
        };
        try {
          await currentPhrase.newAttachment(data);
          currentPhrase.isSaved = true;
          this.setState(prevState => ({
            recordedCount: hasDelete
              ? prevState.recordedCount
              : prevState.recordedCount + 1
          }));
          this.loadNextPhrase(main);
          return;
        } catch (error) {
          this.setState({
            contentloading: false,
            showNotifyDialog: true,
            notifyStatus: "",
            notifyTitle: "Error",
            notifyText: error.message
          });
          console.log(error);
        }
      }.bind(this);
      xhr.send();
    } catch (error) {
      this.setState({
        contentloading: false,
        showNotifyDialog: true,
        notifyStatus: "",
        notifyTitle: "Error",
        notifyText: error.message
      });
      console.log(error);
    }
  };

  deleteAlert = () => {
    this.setState({
      showConfirmDialog: true,
      notifyStatus: "DeleteAlert"
    });
  };

  // Handle deleting a Record
  deleteRecording = async (currentPhrase, main) => {
    this.setState({ contentloading: true });
    const attachemntList = await currentPhrase.getAttachments();
    const targetAttachment = attachemntList.find(
      x => x.language === main && x.type === "audio"
    );
    try {
      await currentPhrase.deleteAttachment(targetAttachment.id);
      currentPhrase.isSaved = false;
      const emptyBlobUrl = "";
      currentPhrase.setRecordedTranslation({ language: main, emptyBlobUrl });
      this.setState(prevState => ({
        contentloading: false,
        showNotifyDialog: true,
        notifyStatus: "DeleteSuccess",
        notifyTitle: "Deleted",
        notifyText: "Audio file is deleted successfully",
        recordedCount: prevState.recordedCount - 1
      }));
    } catch (error) {
      this.setState({ contentloading: false });
      console.log("Error in Delete");
      this.setState({
        contentloading: false,
        showNotifyDialog: true,
        notifyStatus: "",
        notifyTitle: "Error",
        notifyText: error.message
      });
      console.log(error);
    }
  };

  // Handle skipping a Record
  skipRecording = (currentPhrase, main) => {
    delete this.state.targetPhrases[this.state.selectedPhraseId];
    delete this.state.targetPhrasesView[this.state.selectedPhraseId];
    const index = this.phrasesWithoutAttachment.map(e => e.id).indexOf(this.state.selectedPhraseId);
    this.phrasesWithoutAttachment.splice(index, 1);
    var p = this.pageNumber;
    var pLimit = this.pageLimits[p];
    pLimit.end = pLimit.end - 1;
    this.pageLimits[p] = pLimit;
    let pLength = Object.keys(this.pageLimits).length;
    for (var i=p+1; i < pLength; i++) {
      var pLimitl = this.pageLimits[i];
      pLimitl.start = pLimitl.start - 1;
      pLimitl.end = pLimitl.end - 1;
      this.pageLimits[i] = pLimitl;
    }
    var cp = this.currentPointer;
    cp = cp - 1;
    this.currentPointer = cp;
    this.loadNextPhrase(main);
  };

  // Handle the next action for save and delete notification response
  handleNotificationResponse = (currentPhrase, main) => {
    if (this.state.notifyStatus === "DeleteAlert") {
      this.deleteRecording(currentPhrase, main);
      return;
    }
    if (this.state.notifyStatus === "DeleteSuccess") {
      this.setState({
        recordView: "1"
      });
    }
  };

  // Handle loading the next phrase to be loaded based on the user selection or the next non recorded one.
  loadNextPhrase = async main => {

    this.isFromOpenPhrase = false;
    const nextPhraseId =
      this.userSelected !== ""
        ? this.userSelected
        : Object.keys(this.state.targetPhrases).find(
            key =>
              this.state.targetPhrases[key].getRecordedTranslation({
                language: main
              }) === ""
          );
    this.userSelected = "";
    try {
      if (!nextPhraseId) {
        this.setState({ contentloading: false });
        this.setState({
          contentloading: false,
          showNotifyDialog: true,
          notifyStatus: "",
          notifyTitle: "No phrase",
          notifyText: `There are no more unrecorded phrases. Please click the save and sign out button in the top right corner.`
        });
        return;
      }
      const next = this.state.targetPhrases[nextPhraseId];
      const attachemntList = (await next.getAttachments()) || [];
      const targetAttachment = attachemntList.find(
        x => x.language === main && x.type === "audio"
      );
      if (targetAttachment) {
        this.setState({
          recordView: "3",
          selectedPhraseId: nextPhraseId,
          hasUnsavedChanges: false,
          isAttachmentSaved: true,
          contentloading: false
        });
      } else {
        this.setState({
          recordView: "1",
          selectedPhraseId: nextPhraseId,
          hasUnsavedChanges: false,
          isAttachmentSaved: false,
          contentloading: false
        });
      }
      this.currentAudio.src = this.state.targetPhrases[
        nextPhraseId
      ].getRecordedTranslation({
        language: main
      });
    } catch (error) {
      this.setState({ contentloading: false });
      console.log("Error in getting attachments");
      this.setState({
        contentloading: false,
        showNotifyDialog: true,
        notifyStatus: "",
        notifyTitle: "Error",
        notifyText: `Error in fetching next phrase :${error.message}`
      });
      console.log(error);
    }

  };

  // Handling the sinOut
  signOut = () => {
    //HelenAPI.createVersion();
    HelenAPI.signout();
    this.setState({ signOut: true });
  };

  audioControl = () => {
    const { playing } = this.state.audioStatus;
    if (playing) {
      const audioStatus = { ...this.state.audioStatus };
      audioStatus.playing = false;
      this.setState({ audioStatus });
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
    } else {
      const audioStatus = { ...this.state.audioStatus };
      audioStatus.playing = true;
      this.setState({ audioStatus });
      this.currentAudio.play();
    }
  };

  // Rendering the elements in Recorder screen
  render = () => {
    if (this.state.signOut) {
      return <Redirect to="/signin" />;
    }
    const {
      classes,
      languages: { main, secondary }
    } = this.props;
    const { open, recordView, selectedPhraseId } = this.state;
    const { playing, progress } = this.state.audioStatus;
    const currentPhrase = this.state.targetPhrases[selectedPhraseId] || {};
    const { translations = [] } =
      this.state.targetPhrases[selectedPhraseId] || {};
    const { text: mainText = "" } =
      translations.find(({ language }) => language === main) || {};
    const { text: secondaryText = "" } =
      translations.find(({ language }) => language === secondary) || {};
    // Elements for recording a phrase
    const mainContent = (
      <ReactMediaRecorder
        whenStopped={blobUrl => {
          currentPhrase.setRecordedTranslation({ language: main, blobUrl });
          this.currentAudio.src = blobUrl;
        }}
        audio
        render={({ startRecording, stopRecording, mediaBlob }) => (
          <div>
            <Typography variant="subheading" style={{ fontSize: 23 }}>
              {mainText}
            </Typography>
            <br />
            <br />
            <Typography variant="subheading" style={{ fontSize: 18 }}>
              {secondaryText}
            </Typography>
            {recordView === "1" && (
              <div>
                <div className={classes.actionStyles}>
                  <Button
                    className={classes.button}
                    onClick={() => {
                      this.setState({ recordView: "2", counterSecond: 3 });
                      this.interval = setInterval(
                        () => this.tick(startRecording),
                        1000
                      );
                    }}
                    disabled={this.state.contentloading}
                  >
                    <KeyboardVoiceIcon />
                    Record
                  </Button>
                  <input
                    accept="audio/wav"
                    className={classes.hideInput}
                    id="raised-button-file"
                    type="file"
                    onChange={e => {
                      const fileName = e.target.value;
                      const ext = fileName.substring(
                        fileName.lastIndexOf(".") + 1
                      );
                      if (ext !== "wav") {
                        this.setState({
                          errorText: "Upload wav files only"
                        });
                      } else {
                        this.setState({
                          recordView: "4",
                          hasUnsavedChanges: true,
                          errorText: ""
                        });
                        const blobUrl = window.URL.createObjectURL(
                          e.target.files[0]
                        );
                        currentPhrase.setRecordedTranslation({
                          language: main,
                          blobUrl
                        });
                        this.currentAudio.src = blobUrl;
                      }
                    }}
                  />
                  <label htmlFor="raised-button-file">
                    <Button
                      component="span"
                      className={classes.button}
                      disabled={this.state.contentloading}
                    >
                      <FileUploadIcon />
                      Upload
                    </Button>
                  </label>
                  <Button
                    className={classes.button}
                    onClick={() => this.skipRecording(currentPhrase, main)}
                    disabled={this.state.contentloading}
                  >
                    <CancelIcon />
                    Skip
                  </Button>
                </div>
              </div>
            )}
            {recordView === "2" && (
              <div>
                <div className={classes.actionStyles}>
                  {this.state.counterSecond !== 0 && (
                    <Typography
                      variant="subheading"
                      style={{ color: "#004D40", fontSize: 50 }}
                    >
                      {this.state.counterSecond}
                    </Typography>
                  )}
                  {this.state.counterSecond === 0 && (
                    <div>
                      <Typography
                        variant="subheading"
                        style={{ color: "#004D40", fontSize: 25 }}
                      >
                        Recording...
                      </Typography>
                      <Button
                        className={classes.button}
                        onClick={() => {
                          stopRecording();
                          this.setState({
                            recordView: "3",
                            hasUnsavedChanges: true
                          });
                        }}
                        id="stop"
                      >
                        <StopIcon />
                        Stop
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            )}
            {recordView === "3" && (
              <div>
                <div className={classes.actionStyles}>
                  <LinearProgress
                    variant="determinate"
                    value={progress}
                    style={{ height: 25, width: "50%", marginLeft: "25%" }}
                    classes={{
                      barColorPrimary: classes.barColor,
                      colorPrimary:classes.barBackgroundColor
                    }}
                  />
                  <br />
                  <Typography variant="caption" gutterBottom style={{ fontSize: 13 }}>
                    {this.state.audioStatus.playBackTime}/{
                      this.state.audioStatus.duration
                    }
                  </Typography>
                  <br />
                  <Button
                    className={classes.button}
                    onClick={() => {
                      this.setState({ recordView: "2", counterSecond: 3 });
                      this.interval = setInterval(
                        () => this.tick(startRecording),
                        1000
                      );
                    }}
                    disabled={this.state.contentloading}
                  >
                    <KeyboardVoiceIcon />
                    Re-Record
                  </Button>
                  <Button
                    className={classes.button}
                    onClick={() => this.audioControl()}
                    disabled={this.state.contentloading}
                  >
                    {playing ? <StopIcon /> : <PlayArrowIcon />}
                    {playing ? "Stop" : "Play"}
                  </Button>
                  <Button
                    className={classes.button}
                    id="download"
                    onClick={() => {
                      const click = document.createEvent("Event");
                      click.initEvent("click", true, true);
                      const link = document.createElement("a");
                      link.href = currentPhrase.getRecordedTranslation({
                        language: main
                      });
                      link.download = "Recording";
                      link.dispatchEvent(click);
                      link.click();
                      return link;
                    }}
                    disabled={this.state.contentloading}
                  >
                    <FileDownloadIcon />
                    Download
                  </Button>
                  {this.state.isAttachmentSaved && (
                    <Button
                      className={classes.button}
                      onClick={() => this.deleteAlert()}
                      disabled={this.state.contentloading}
                    >
                      <DeleteIcon />
                      Delete
                    </Button>
                  )}
                </div>
                <br />
                <div style={{ textAlign: "right" }}>
                  <Button
                    className={classes.button}
                    onClick={() => this.saveRecording(currentPhrase, main)}
                    disabled={this.state.contentloading}
                  >
                    <SaveIcon />
                    Save
                  </Button>
                  <Button
                    className={classes.button}
                    onClick={() => this.setState({ showSkipDialog: true })}
                    disabled={this.state.contentloading}
                  >
                    <CancelIcon />
                    Skip
                  </Button>
                </div>
              </div>
            )}
            {recordView === "4" && (
              <div>
                <div className={classes.actionStyles}>
                  <LinearProgress
                    variant="determinate"
                    value={progress}
                    style={{ height: 25, width: "50%", marginLeft: "25%" }}
                    classes={{
                      barColorPrimary: classes.barColor,
                      colorPrimary:classes.barBackgroundColor
                    }}
                  />
                  <br />
                  <Typography variant="caption" gutterBottom  style={{ fontSize: 13 }}>
                    {this.state.audioStatus.playBackTime}/{
                      this.state.audioStatus.duration
                    }
                  </Typography>
                  <br />
                  <input
                    accept="audio/wav"
                    className={classes.hideInput}
                    id="raised-button-file"
                    type="file"
                    onChange={e => {
                      const fileName = e.target.value;
                      const ext = fileName.substring(
                        fileName.lastIndexOf(".") + 1
                      );
                      if (ext !== "wav") {
                        this.setState({
                          errorText: "Upload wav files only"
                        });
                      } else {
                        this.setState({
                          errorText: "",
                          hasUnsavedChanges: true
                        });
                        const blobUrl = window.URL.createObjectURL(
                          e.target.files[0]
                        );
                        currentPhrase.setRecordedTranslation({
                          language: main,
                          blobUrl
                        });
                        this.currentAudio.src = blobUrl;
                      }
                    }}
                  />
                  <label htmlFor="raised-button-file">
                    <Button
                      component="span"
                      className={classes.button}
                      disabled={this.state.contentloading}
                    >
                      <FileUploadIcon />
                      Re-Upload
                    </Button>
                  </label>
                  <Button
                    className={classes.button}
                    onClick={() => this.audioControl()}
                    disabled={this.state.contentloading}
                  >
                    {playing ? <StopIcon /> : <PlayArrowIcon />}
                    {playing ? "Stop" : "Play"}
                  </Button>
                  {this.state.isAttachmentSaved && (
                    <Button
                      className={classes.button}
                      onClick={() => this.deleteAlert()}
                      disabled={this.state.contentloading}
                    >
                      <DeleteIcon />
                      Delete
                    </Button>
                  )}
                </div>
                <br />
                <div style={{ textAlign: "right" }}>
                  <Button
                    className={classes.button}
                    onClick={() => this.saveRecording(currentPhrase, main)}
                    disabled={this.state.contentloading}
                  >
                    <SaveIcon />
                    Save
                  </Button>
                  <Button
                    className={classes.button}
                    onClick={() => this.setState({ showSkipDialog: true })}
                    disabled={this.state.contentloading}
                  >
                    <CancelIcon />
                    Skip
                  </Button>
                </div>
              </div>
            )}
            {this.state.errorText !== "" && (
              <Typography
                variant="subheading"
                style={{
                  color: "#D50000",
                  fontSize: 16,
                  textAlign: "center",
                  marginTop: 10
                }}
              >
                {this.state.errorText}
              </Typography>
            )}
          </div>
        )}
      />
    );
    const recorderContent = mainContent;

    // An item in left side drawer
    const PhraseItem = props => (
      <div>
        <Typography variant="subheading" style={{ marginTop: 20 }}>
          {props.translations.find(x => x.language === main).text}
          {props.isCheck && (
            <CheckCircle
              style={{
                fontSize: 20,
                paddingTop: 3,
                color: "#009688",
                paddingLeft: 10,
                position: "absolute"
              }}
            />
          )}
        </Typography>

        <Button
          className={classes.openButton}
          onClick={() => {
            if (selectedPhraseId === props.phraseId) {
              return;
            }
            this.isFromOpenPhrase = true;
            this.userSelected = props.phraseId;
            this.setState({selectedPhraseId: props.phraseId})
            if (!this.state.hasUnsavedChanges) {
              this.setState({ contentloading: true });
              this.loadNextPhrase(main);
            } else {
              this.setState({
                showSkipDialog: true
              });
            }
          }}
          disabled={this.state.contentloading}
        >
          Open
        </Button>
        <Divider />
      </div>
    );

    // Sliding Drawer
    const drawer = (
      <Drawer
        variant="persistent"
        anchor="left"
        classes={{
          paper: classes.drawerPaper
        }}
        open={open}
      >
        <div className={classes.pagingWrapper}>
            <Button
                className={classes.previousButton}
                onClick={() => {
                  console.log("Previous Clicked.")
                  var phrasesWithoutAttachment = [];
                  var page = this.pageNumber;
                  console.log(page);
                  if (page === 0){
                    //no more prev dialog
                    return;
                  }else{
                    let p = this.pageNumber;
                    var pLimits = this.pageLimits;
                    pLimits[p].recordedCount = this.state.recordedCount;
                    var pageToLoad = p - 1;
                    var pLimit = this.pageLimits[pageToLoad];
                    phrasesWithoutAttachment = this.phrasesWithoutAttachment.slice(pLimit.start, pLimit.end + 1);
                    this.currentPointer = pLimit.end;
                    this.setState({recordedCount: pLimit.recordedCount});
                    this.pageNumber = pageToLoad;
                    this.pageLimits = pLimits;
                  }
                  const [defaultPhrase] = phrasesWithoutAttachment;
                  const phrasesObject = phrasesWithoutAttachment.reduce(
                    (acl, curr) =>
                      Object.assign({}, acl, {
                        [curr.id]: curr
                      }),
                    {}
                  );

                  const phrasesObjectView = phrasesWithoutAttachment.reduce(
                    (acl, curr) =>
                      Object.assign({}, acl, {
                        [curr.id]: curr
                      }),
                    {}
                  );
                  this.userSelected = "";
                  let state = {
                    currentPhrasesWithoutAttachment: phrasesWithoutAttachment,
                    targetPhrases: phrasesObject,
                    targetPhrasesView: phrasesObjectView,
                    selectedPhraseId: defaultPhrase.id,
                    loading: false
                  }
                  const { main } = this.props.languages;
                  this.setState(state, () => this.loadNextPhrase(main));
                }}>
                Previous
            </Button>
            <div className={classes.currentPage}>
            {this.pageNumber + 1}/{this.state.pageCount}
            </div>
            <Button
                className={classes.nextButton}
                onClick={async() => {
                  console.log("Next Clicked.")
                  var phrasesWithoutAttachment = [];
                  var current = this.currentPointer;
                  var end = this.phrasesWithoutAttachment.length - 1;
                  if(current === end){
                    if(this.allPhraseLoaded) {
                      this.setState({
                        loading: false
                      });
                      return;
                    }
                    this.setState({
                      loading: true
                    });
                    await this.getPhrasesWithoutAttachment();
                    phrasesWithoutAttachment= this.tempPhrasesWithoutAttach;

                    if(phrasesWithoutAttachment.length){
                      this.phrasesWithoutAttachment = this.phrasesWithoutAttachment.concat(phrasesWithoutAttachment);
                      var l = phrasesWithoutAttachment.length;
                      var page = {
                        "start": current + 1,
                        "end": current + l,
                        "recordedCount":0
                      };
                      var p = this.pageNumber + 1;
                      this.pageLimits[p] = page;
                      this.pageNumber = p;
                      this.currentPointer += phrasesWithoutAttachment.length;
                      this.pageLimits[this.pageNumber].recordedCount = this.state.recordedCount;
                      this.setState({recordedCount: 0});
                    } else {
                      //no more phrases
                      this.allPhraseLoaded = true;
                      this.setState({
                        loading: false
                      });
                      return;
                    }
                  } else {
                    let p = this.pageNumber;
                    var pLimits = this.pageLimits;
                    pLimits[p].recordedCount = this.state.recordedCount;
                    var pageToLoad = p + 1;
                    var pLimit = pLimits[pageToLoad];
                    phrasesWithoutAttachment = this.phrasesWithoutAttachment.slice(pLimit.start, pLimit.end + 1);
                    this.currentPointer = pLimit.end;
                    this.pageNumber = pageToLoad;
                    this.pageLimits = pLimits;
                    const { main } = this.props.languages;
                    this.setState({recordedCount: pLimit.recordedCount}, () => this.loadNextPhrase(main));
                  }
                  
                  const [defaultPhrase] = phrasesWithoutAttachment;
                  const phrasesObject = phrasesWithoutAttachment.reduce(
                    (acl, curr) =>
                      Object.assign({}, acl, {
                        [curr.id]: curr
                      }),
                    {}
                  );
                  const phrasesObjectView = phrasesWithoutAttachment.reduce(
                    (acl, curr) =>
                      Object.assign({}, acl, {
                        [curr.id]: curr
                      }),
                    {}
                  );
                  this.userSelected = "";
                  this.setState({
                    currentPhrasesWithoutAttachment: phrasesWithoutAttachment,
                    targetPhrases: phrasesObject,
                    targetPhrasesView: phrasesObjectView,
                    selectedPhraseId: defaultPhrase.id,
                    loading: false
                  });
                }}
                >
                Next
            </Button>
        </div>

        {Object.keys(this.state.targetPhrasesView).map(key => {
          let isSavedItem = false;
          if (this.state.targetPhrasesView[key].isSaved) {
            isSavedItem = true;
          }
          return (
            <PhraseItem
              key={key}
              phraseId={key}
              isCheck={isSavedItem}
              translations={this.state.targetPhrasesView[key].translations}
            />
          );
        })}
      </Drawer>
    );

    // Main view
    return (
      <div>
        {this.state.inValidOperation && (
          <div>
            <Typography
              variant="display2"
              style={{ fontSize: 23, marginTop: 20, marginLeft: 10 }}
            >
              Invalid Operation !
            </Typography>
          </div>
        )}

        {this.state.loading && (
          <CircularProgress
            className={classes.progress}
            style={{ color: "#004D40", marginLeft: "50%", marginTop: "15%" }}
            size={75}
          />
        )}
        {!this.state.loading &&
          !this.state.inValidOperation && (
            <div>
              <IconButton
                onClick={() => this.setState({ open: false })}
                className={classNames(
                  classes.leftButton,
                  !open && classes.hide
                )}
              >
                <ChevronLeftIcon />
              </IconButton>
              {drawer}
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={() => {
                  this.setState({ open: true });
                }}
                className={classNames(classes.menuButton, open && classes.hide)}
              >
                <MenuIcon />
              </IconButton>
              <div
                className={classNames(classes.content, {
                  [classes.contentShift]: open,
                  [classes.contentShiftLeft]: open
                })}
              >
                <Button
                  variant="raised"
                  color="primary"
                  className={classes.raisedButton}
                  onClick={() => this.signOut()}
                >
                  Save and Sign Out
                </Button>
                <Typography
                  variant="caption"
                  gutterBottom
                  align="right"
                  className={classes.progressStyle}
                >
                  {this.state.recordedCount}/{Object.keys(this.state.targetPhrases).length}
                </Typography>
                {this.state.contentloading && (
                  <CircularProgress
                    size={24}
                    style={{
                      color: "#004D40",
                      marginRight: 177,
                      marginTop: -28,
                      float: "right"
                    }}
                  />
                )}
                <div className={classes.contentStyling}>{recorderContent}</div>
              </div>
            </div>
          )}
        <SkipDialog
          open={this.state.showSkipDialog}
          onClose={() => this.setState({ showSkipDialog: false })}
          onSkip={() => {
            this.setState({ showSkipDialog: false });
            this.skipRecording(currentPhrase, main);
          }}
          onSave={() => {
            this.setState({ showSkipDialog: false });
            this.saveRecording(currentPhrase, main);
          }}
          text="Are you sure you want to skip without saving"
          title="Unsaved Changes"
        />
        <AppDialog
          open={this.state.showNotifyDialog}
          onClose={() => {
            this.setState({ showNotifyDialog: false });
            this.handleNotificationResponse(currentPhrase, main);
          }}
          text={this.state.notifyText}
          title={this.state.notifyTitle}
        />
        <ConfirmDialog
          open={this.state.showConfirmDialog}
          onClose={() => this.setState({ showConfirmDialog: false })}
          onOk={() => {
            this.setState({ showConfirmDialog: false });
            this.handleNotificationResponse(currentPhrase, main);
          }}
          onCancel={() => {
            this.setState({ showConfirmDialog: false });
          }}
          text="Are you sure you want to delete this recording?"
          title="Delete Confirmation"
        />
      </div>
    );
  };
}

Recorder.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  languages: PropTypes.object.isRequired,
  version: PropTypes.object.isRequired,
  setAppBar: PropTypes.func.isRequired
};
export default withStyles(styles, { withTheme: true })(Recorder);



// WEBPACK FOOTER //
// ./src/components/Recorder.jsx